import React, { useEffect } from "react";
import { useIntl } from 'react-intl';

// Components
import Select from 'Components/Select';
import { Form } from 'Components';


export const FuelCard = (props) => {

    const { value, onChange, formRef } = props
    const { messages } = useIntl()

    useEffect(() => {
        if (value.fuelCardEvent == undefined)
            onChange({
                ...value,
                fuelCardEvent: ''
            })
    }, [value])

    const dropdownOptions = [
        { selectId: 'NotAtLocation', name: messages['alertsNewAlert_NotAtLocation'] },
        { selectId: 'Overfill', name: messages['alertsNewAlert_Overfill'] },
    ];
    return (
        <Form ref={formRef} >
            <Select
                required
                value={dropdownOptions.find((option) => option.selectId === value.fuelCardEvent)}
                onChange={(newValue) => onChange({ ...value, fuelCardEvent: newValue.selectId })}
                id="fuelCardSelect"
                placeholder={messages['alertsNewAlert_SelectPlaceholder']}
                options={dropdownOptions}
                textField="name"
                valueField="selectId"
                label={messages['alertsNewAlert_Event']}
                requiredMessage={messages['required_field']}
            />
        </Form>
    );
}
